<template>
  <!-- 经纬度搜索 -->
  <div class="wrapper">
    <div class="container">
      <div>
        <div class="input-suffix">
          <div class="input-lon">经度:</div>
          <el-input
                  ref="lon"
            v-model="lon"
            @keyup.native="
              lon = lon.replace(/^\D*(\d*(?:\.\d{0,6})?).*$/g, '$1')
            "
            placeholder="经度范围0~180.例如：115.123"
            :style="{ borderRadius: '18px' }"
            @input="inputLonClick"
            @keydown.enter.native="lonEnter"
          ></el-input>
        </div>
        <div class="input-suffix">
          <div class="input-lat">纬度:</div>
          <el-input
            ref="latInput"
            v-model="lat"
            style="margin-top: 10px"
            @keyup.native="
              lat = lat.replace(/^\D*(\d*(?:\.\d{0,6})?).*$/g, '$1')
            "
            placeholder="纬度范围0~90.例如：40.123"
            @input="inputLatClick"
            @keydown.enter.native="handleENClick"
          ></el-input>
        </div>
      </div>
      <el-button type="primary" @click="handleENClick" class="btn-wrapper"
        >定位</el-button
      >
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      lon: '',
      lat: '',
    };
  },
  mounted() {
    this.$nextTick(function(){
      this.$refs.lon.focus();
    });
  },
  methods: {
    inputLonClick() {
      this.seatLong = this.conversionUtils(this.lon);
      if (+this.seatLong > 180 || +this.seatLong < 0) {
        this.lon = '';
        this.seatLong = '';
        return this.$message.warning('经度范围应在0°至180°之间');
      }
      console.log(this.seatLong, ' this.lon');
    },
    inputLatClick() {
      this.seatLat = this.conversionUtils(this.lat);
      if (+this.seatLat > 90 || +this.seatLat < 0) {
        this.lat = '';
        this.seatLat = '';
        return this.$message.warning('纬度范围应在0°至90°之间');
      }
      console.log(this.seatLat, ' this.lat');
    },
    conversionUtils(lat) {
      var latHour = 0;
      var latMinute = 0;
      var latSecond = 0;
      if (/^(\d)+\.(\d)+$/.test(lat) || /^[0-9]*[1-9][0-9]*$/.test(lat)) {
        return lat;
      } else {
        if (lat.search('°') !== -1) {
          latHour = lat.split('°')[0];
          if (
            lat.search("'") !== -1 ||
            lat.search('‘') !== -1 ||
            lat.search('’') !== -1 ||
            lat.search('′') !== -1
          ) {
            var min = lat.split('°')[1];
            console.log('min', min);
            latMinute =
              min.split("'")[0] ||
              min.split('‘')[0] ||
              min.split('’')[0] ||
              min.split('′')[0];
          }
          if (
            lat.search('”') !== -1 ||
            lat.search('“') !== -1 ||
            lat.search('""') !== -1 ||
            lat.search('″') !== -1
          ) {
            if (
              lat.search("'") !== -1 ||
              lat.search('‘') !== -1 ||
              lat.search('’') !== -1 ||
              lat.search('′') !== -1
            ) {
              latSecond =
                lat.split("'")[1] ||
                lat.split('‘')[1] ||
                lat.split('’')[1] ||
                lat.split('′')[1];
            } else {
              latSecond = lat.split('°')[1];
            }
          }
        } else {
          return 0;
        }
      }
      console.log('latSecond', latSecond);
      console.log('latMinute', parseFloat(latMinute));
      console.log('latHour', latHour);
      var v =
        parseFloat(latHour) +
        parseFloat(parseFloat(latMinute) / 60) +
        parseFloat(parseFloat(latSecond) / 60 / 60);
      return v;
    },

    lonEnter() {
      this.$refs.latInput.focus();
    },

    handleENClick() {
      if (!this.lat || !this.lon) {
        return this.$message.warning('请输入经纬度');
      }
      var regionPoint = {
        type: 'markers',
        data: { lng: +this.seatLong, lat: +this.seatLat },
      };
      this.$bus.$emit('create-point-list', regionPoint);
      this.$emit('close');
    },
  },
};
</script>
<style scoped lang="less">
.wrapper {
  position: absolute;
  top: 135px;
  right: 50px;
  z-index: 1500;
  background: rgba(255, 255, 255, 0.9);
  color: @black-color;
  padding: 20px;
  width: 314px;
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
  
  /deep/ .el-input__inner {
    background: rgba(255, 255, 255, 0.6);
  }
}
.container {
  text-align: right;
}
.input-suffix {
  display: flex;
  margin-top: 5px;
  .input-lon {
    width: 50px;
    margin-top: 6px;
    margin-right: 10px;
  }
  .el-input__inner {
    border-radius: 18px !important;
  }
  .input-lat {
    width: 50px;
    margin-top: 17px;
    margin-right: 10px;
  }
}
.btn-wrapper {
  margin-top: 15px;
}
</style>
